import type { Definition } from '@hotwired/stimulus'
import { definitionForModuleAndIdentifier, identifierForContextKey } from '@hotwired/stimulus-webpack-helpers'
import type { ECMAScriptModule } from '@hotwired/stimulus-webpack-helpers'

interface ControllerContext {
  (key: string): ECMAScriptModule
  keys(): string[]
}

type ControllerLoadErrorHandler = (error: Error, key: string) => void

// definitionsFromContext throws on the first module that fails to evaluate, losing every
// controller; this skips only the failing module.
// eslint-disable-next-line import/prefer-default-export
export function isolatedDefinitionsFromContext(
  context: ControllerContext,
  onError: ControllerLoadErrorHandler,
): Definition[] {
  const definitions: Definition[] = []

  context.keys().forEach((key) => {
    const identifier = identifierForContextKey(key)
    if (!identifier) return

    try {
      const definition = definitionForModuleAndIdentifier(context(key), identifier)
      if (definition) definitions.push(definition)
    } catch (error) {
      onError(error as Error, key)
    }
  })

  return definitions
}
